import { Segmented } from 'antd';
import React, { useEffect, useState } from "react";
import AdminIngredient from './AdminIngredient';
import AdminProduct from './AdminProduct';
import AdminRecipe from './AdminRecipe';
import AdminUser from './AdminUser';
import "./AdminPage.css";

const Tabs = {
    Ingredient: 0,
    Recipe: 1,
    Product: 2,
    User: 3
}

const AdminPage = () => {

    const [tab, setTab] = useState(Tabs.Ingredient);

    const subSite = () => {
        switch (tab) {
            case 0: return <AdminIngredient />
            case 1: return <AdminRecipe />
            case 2: return <AdminProduct />
            case 3: return <AdminUser />
            default: console.log("NO SELECTED");
        }
    }

    return (
        <div>
            <Segmented
                className='tabSelect'
                options={['Ingredient', 'Recipe', 'Product', 'User']}
                shape='round'
                block
                onChange={(value) => {
                    switch (value) {
                        case "Ingredient": setTab(Tabs.Ingredient); break;
                        case "Recipe": setTab(Tabs.Recipe); break;
                        case "Product": setTab(Tabs.Product); break;
                        case "User": setTab(Tabs.User); break;
                    }
                }}
            />
            {subSite()}
        </div>
    );
};



export default AdminPage;